// extracted by mini-css-extract-plugin
export default {"TrilhasPage":"trilhaspage_TrilhasPage__+IoKu","containerTop":"trilhaspage_containerTop__bA+Rp","title":"trilhaspage_title__MdHO5","containerList":"trilhaspage_containerList__SvLWJ"};